import Vue from 'vue'
import VueAMap from 'vue-amap'

Vue.use(VueAMap)

VueAMap.initAMapApiLoader({
  key: '8ef2d94c7838427c363be885005f7784',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool','AMap.ElasticMarker', 'AMap.Geocoder', 'AMap.LngLat'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.14'
})
